import { useMemo } from 'react'
import type { ReactNode } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import AuthRouteComponent from './AuthRouteComponent'
import type { AppRouteMatch } from './routeTypes'

interface Props {
  accountAccessModalInitialMode?: App.UiAccountModalMode
  children: ReactNode
  loader?: ReactNode
  path: string
  showPopup?: boolean
}

function AuthRouteElement(props: Props) {
  const {
    accountAccessModalInitialMode,
    children,
    loader,
    path,
    showPopup,
  } = props
  const location = useLocation()
  const params = useParams()
  const match = useMemo<AppRouteMatch>(() => ({
    isExact: true,
    params,
    path,
    url: location.pathname,
  }), [location.pathname, params, path])

  return (
    <AuthRouteComponent
      accountAccessModalInitialMode={accountAccessModalInitialMode}
      loader={loader}
      match={match}
      showPopup={showPopup}
    >
      {children}
    </AuthRouteComponent>
  )
}

export default AuthRouteElement
